import { useEffect, useRef, useState } from "react";
import { loadHubSpotEmbed } from "@/lib/hubspotLoader";

const FORM_ID = "5f72be84-200f-4e04-86e0-b67c197316d0";
const PORTAL_ID = "23440002";
const REGION = "na1";

export default function CorporateHubSpotForm() {
  const containerRef = useRef<HTMLDivElement>(null);
  const targetRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); io.disconnect(); } },
      { rootMargin: "200px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  useEffect(() => {
    if (!visible) return;
    let cancelled = false;
    loadHubSpotEmbed()
      .then(() => {
        if (cancelled) return;
        const hbspt = (window as any).hbspt;
        const target = targetRef.current;
        if (!hbspt?.forms || !target) return;
        target.innerHTML = "";
        hbspt.forms.create({
          region: REGION,
          portalId: PORTAL_ID,
          formId: FORM_ID,
          target: `#${target.id}`,
          onFormSubmitted: () => {
            window.location.assign("/thank-you?type=corporate");
          },
        });
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [visible]);

  return (
    <div ref={containerRef} className="text-left">
      <div ref={targetRef} id="hs-form-target-corporate" />
    </div>
  );
}